// extracted by mini-css-extract-plugin
export default {"button":"_2m3l8U9IgMj1kgpDHZom8i"};